import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { ProfileService } from '@shared/services/api/profile.service';
import { take } from 'rxjs';

@Directive({
  selector: '[appHasRole], [appHasRoleOrRolesAreEmpty]'
})
export class HasRoleDirective {
  @Input() set appHasRole(roles: string[]) {
    this.profileService.role$.pipe(take(1)).subscribe((role) => {
      if (roles && roles.includes(role)) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainerRef.clear();
      }
    });
  }

  @Input() set appHasRoleOrRolesAreEmpty(roles: string[]) {
    this.profileService.role$.pipe(take(1)).subscribe((role) => {
      if (roles.length === 0 || roles.includes(role)) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainerRef.clear();
      }
    });
  }

  constructor(
    private profileService: ProfileService,
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef
  ) {}
}
